import * as React from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Card,
  Typography,
  Divider,
  MenuItem,
  MenuList,
  ListItemText
} from '@mui/material'

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';

import { CSettingButton, CSettingPopOver } from '../components/common/Modal';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';

import ScheduleModal from '../modals/ScheduleModal';
import VisualizationModal from '../modals/VisualizationModal';

import Layout from '../components/GridLayout/Layout';
import Toolbar from '../components/Toolbar'

import { API_URI } from '../const';
import { getVisualization, saveVisualization } from '../slices/visualization';


export default function VisualizationDetail() {
  const { id } = useParams();
  const data = useSelector((state) => state.visualization.data);
  const layouts = useSelector((state) => state.visualization.layouts);
  
  const [anchorDownloadEl, setAnchorDownloadEl] = React.useState(null);
  const [openVisual, setOpenVisual] = React.useState(false);
  const [openSchedule, setOpenSchedule] = React.useState(false);
  const [loading, setLoading] = React.useState(false);


  const openDownload = Boolean(anchorDownloadEl);
  const downloadId = openDownload ? 'download-popover' : undefined;

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(getVisualization({id}));
  }, [dispatch, id]);

  const handleCreateVisualization = () => {
    setOpenVisual(true);
  }

  const handleCloseVisual = (e) => {
    setOpenVisual(false);
  }
  
  const handleSchedule = async () => {
    setOpenSchedule(true);
  }

  const handleDownloadMenu = (e) => {
    setAnchorDownloadEl(e.currentTarget);
  }

  const handleDownloadClose = () => {
    setAnchorDownloadEl(null);
  };
  
  const handleDownloadPDF = async () => {
    setAnchorDownloadEl(null);
    const token = localStorage.getItem("token");  

    const config = {  
      method: 'get',  
      url: `${API_URI}v1/user/visualization/${id}/generate`,  
      responseType: 'blob',  
      headers: {  
        Authorization: `Bearer ${token}`,  
        'ngrok-skip-browser-warning': true,        
        'Content-Type': 'application/json',  
      },  
    };  
  
    setLoading(true);  
  
    try {  
      const response = await axios.request(config);  
      const blob = response.data;  
  
      const url = window.URL.createObjectURL(blob);  
      const a = document.createElement('a');  
      a.href = url;  
      a.download = 'dashboard.pdf';  
      document.body.appendChild(a);  
      a.click();  
      document.body.removeChild(a);  
  
      setLoading(false);  
    } catch (err) {  
      console.log(err);  
      window.alert("I can't generate the powerpoint for the prompts");  
      setLoading(false);  
    }  
    // const input = document.getElementById('dashboard-content');
    // const canvas = await html2canvas(input);
    // const imgData = canvas.toDataURL('image/png');

    // const screenWidth = window.innerWidth;
    // // const screenHeight = window.innerHeight;

    // const maxImgWidth = screenWidth - 10;

    // const imgWidth = Math.min(210, maxImgWidth);
    // const imgHeight = canvas.height * imgWidth / canvas.width;

    // // Initialize PDF document
    // const pdf = new jsPDF({
    //   orientation: 'landscape',
    //   unit: 'mm',
    //   format: [imgWidth, imgHeight],
    // });

    // const marginTop = 0;
    // const marginLeft = 0;

    // const xPos = (pdf.internal.pageSize.getWidth() - imgWidth) / 2;
    // let yPos = marginTop;

    // pdf.addImage(imgData, 'PNG', xPos + marginLeft, yPos, imgWidth, imgHeight);

    // let remainingHeight = pdf.internal.pageSize.getHeight() - yPos - imgHeight;
    // let currentPage = 1;

    // while (remainingHeight < 0) {
    //   pdf.addPage();
    //   currentPage++;
    //   yPos = marginTop - (pdf.internal.pageSize.getHeight() * (currentPage - 1));
    //   pdf.addImage(imgData, 'PNG', xPos + marginLeft, yPos, imgWidth, imgHeight);
    //   remainingHeight = pdf.internal.pageSize.getHeight() - yPos - imgHeight;
    // }

    // // Save PDF
    // pdf.save('dashboard.pdf');
  }

  const handleSaveVisualization = () => {
    dispatch(saveVisualization({id, data, layouts}))
  }

  const handleSaveSchedule = () => {
    setOpenSchedule(false)
  }

  return (
    <Box className="w-full h-full ">
      <Toolbar/>
      <Box className="content-height" sx={{padding: 4}}>
        <Card className='h-full flex flex-column border-content' sx={{boxShadow: 'rgba(145, 158, 171, 0.3) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px'}}>
          <Box className='flex flex-row align-center' sx={{padding: 3, flexGrow: 0}}>
            <Typography variant='h6' sx={{flexGrow: 1, minWidth: 200}}>Visualization Detail</Typography>
            <Box
              className="w-full flex"
              sx={{
                alignItems: 'center',
                justifyContent: 'flex-end',
                gap: 1
              }}
            >
              <CSettingButton
                sx={{
                  color: 'white',
                  padding: '0.25rem 1rem',
                  background: '#FA896B',
                  '&:hover': {
                    background: '#FF976C'
                  }
                }}
                onClick={handleSaveVisualization}
              >
                Save Visualization
              </CSettingButton>
              <CSettingButton
                sx={{
                  background: '#5D87FF',
                  color: 'white',
                  padding: '0.25rem 1rem',
                  '&:hover': {
                    background: '#6695FF'
                  }
                }}
                onClick={handleCreateVisualization}
              >
                Add Visualization
              </CSettingButton>
              <CSettingButton
                sx={{
                  height: 30,
                  width: 30,
                  color: '#404040'
                }}
                onClick={handleDownloadMenu}
              >
                <MoreVertOutlinedIcon
                  fontSize='smaller'
                />
              </CSettingButton>
            </Box>
          </Box>
          <Divider/>
          <Box id="dashboard-content" sx={{overflowY: 'auto'}}>
            <Layout 
              data={data}
              layouts={layouts}
            />
          </Box>
        </Card>
      </Box>
      <CSettingPopOver
        id={downloadId}
        open={openDownload}
        anchorEl={anchorDownloadEl}
        onClose={handleDownloadClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{
          marginTop: 1
        }}
        disableScrollLock
      >
        <MenuList dense>
          <MenuItem>
            <ListItemText>Refresh Visualization</ListItemText>
          </MenuItem>
          <MenuItem onClick={handleSchedule}>
            <ListItemText>Schedule Visualization</ListItemText>
          </MenuItem>
          <MenuItem onClick={handleDownloadPDF}>
            <ListItemText>Export dashboard as PDF</ListItemText>
          </MenuItem>
        </MenuList>
      </CSettingPopOver>
      <VisualizationModal 
        open={openVisual}
        handleClose={handleCloseVisual}
      />
      <ScheduleModal
        open={openSchedule}
        handleSave={handleSaveSchedule}
        handleClose={() => setOpenSchedule(false)}
      />
    </Box>
  );
}